export default "__VITE_ASSET__DPGqIv17__"